// extracted by mini-css-extract-plugin
module.exports = {"table-react":"StyledTableCell_table-react__1PwkR","stick-head":"StyledTableCell_stick-head__12__b","MuiTableCell-stickyHeader":"StyledTableCell_MuiTableCell-stickyHeader__338AU"};